
export class Thermo {
    keycode: string;
    devcode: string;
    Description: string;
    ProductTypeId: number;
    current_season: string;
    mode: string;
    temp_loc: number;
    manual_temp: number;
    hum_loc: number;
    set_mode: string;
    set_manual_temp: number;
    on_line: number;
    relay_status: number;
    error: string;
    signal_level: string;
}

export class DevicesThermo {
    system: boolean;
    user: string;
    name: string;
    items: Thermo[];
}

export class ThermoLog {
    Keycode: string;
    IntervalType: string;
    From: number;
    To: number;
    PowerOnTime: ThermoStats;
    Humidity: ThermoStats;
    SetPoint: ThermoStats;
    InternalTemperature: ThermoStats;
    ExternalTemperature: ThermoStats;
    ConnectionEvents: ThermoStats;
}

export class ThermoStats {
    Average: number;
    List: ThermoStatsValue[];
}

export class ThermoStatsValue {
    Timestamp: number;
    Value: string;
}